"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Legacy() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const paragraphs = ["MYB Services began 26 years ago, founded on the principle that environmental safety is not a luxury, but a clinical necessity. What started as a specialized mission to protect local families from hidden hazards has grown into the region's most trusted authority in mold inspection and environmental testing.", "We exist for the moment a homeowner stops worrying and starts knowing. Our work lives at the intersection of rigorous scientific methodology, advanced diagnostic technology, and clear, actionable reporting — providing the evidence you need to breathe easier in your own home.", "Today, we partner with homeowners, property managers, and real estate professionals across Dade, Broward, and West Palm counties. The technology has evolved. Our commitment to precision and clinical integrity has not."];
  return <section data-section-id="3710" id="a-legacy-of-precision" className="bg-background text-foreground pt-[200px] pb-32 px-6 md:px-12 lg:px-20 overflow-hidden font-default">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div ref={headlineRef} className={`mb-24 md:mb-32 transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-12 bg-primary" />
            <span className="font-mono text-xs uppercase tracking-widest text-primary">
              Our Clinical DNA
            </span>
          </div>
          <h2 className="font-default font-bold leading-[1.02] tracking-tight text-foreground" style={{
          fontSize: "clamp(2.75rem, 7vw, 7rem)"
        }}>
            MYB Services — a team of certified inspectors and environmental scientists building the standard for{" "}
            <em className="italic text-primary font-normal">clinical trust</em>.
          </h2>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-32 md:mb-40">
          {}
          <div className={`lg:col-span-5 transition-all duration-1000 delay-150 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="flex items-start gap-4 mb-12">
              <div className="flex flex-col items-center pt-1">
                <div className="h-2 w-2 rounded-lg bg-primary" />
                <div className="w-px h-20 bg-gradient-to-b from-primary to-transparent mt-2" />
              </div>
              <div>
                <p className="font-mono text-xs uppercase tracking-widest text-primary">
                  26 YEARS
                </p>
                <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mt-1">
                  South Florida
                </p>
              </div>
            </div>

            <div className="space-y-8">
              <div>
                <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-3">
                  01 — Origin
                </p>
                <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/80">
                  {paragraphs[0]}
                </p>
              </div>

              <div>
                <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-3">
                  02 — Philosophy
                </p>
                <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/80">
                  {paragraphs[1]}
                </p>
              </div>

              <div>
                <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-3">
                  03 — Today
                </p>
                <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/80">
                  {paragraphs[2]}
                </p>
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-7 lg:col-start-6 transition-all duration-1000 delay-300 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="relative w-full overflow-hidden rounded-lg shadow-lg" style={{
            aspectRatio: "3 / 4"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/clinical_inspection_site.png" alt="MYB Services inspector performing a professional environmental assessment" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

              {}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(160deg, transparent 0%, transparent 50%, hsla(208, 72%, 50%, 0.18) 85%, hsla(208, 72%, 50%, 0.32) 100%)"
            }} />
              <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(180deg, hsla(223, 83%, 9%, 0.3) 0%, transparent 30%, transparent 70%, hsla(223, 83%, 9%, 0.5) 100%)"
            }} />

              {}
              <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 max-w-[280px]">
                <div className="backdrop-blur-sm bg-background/80 border border-border rounded-lg px-5 py-4 shadow-md">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="h-1.5 w-1.5 rounded-lg bg-primary" />
                    <span className="font-mono text-[10px] uppercase tracking-widest text-primary">
                      Service Area
                    </span>
                  </div>
                  <p className="font-mono text-xs uppercase tracking-wider text-foreground leading-relaxed">
                    Dade • Broward
                    <br />
                    <span className="text-foreground/60">— West Palm Counties</span>
                  </p>
                </div>
              </div>

              {}
              <div className="absolute top-6 left-6 hidden md:block">
                <p className="font-mono text-[10px] uppercase tracking-widest text-foreground/70">
                  [ Clinical / 04 ]
                </p>
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={quoteRef} className={`max-w-6xl mx-auto text-center transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center justify-center gap-3 mb-10">
            <span className="h-px w-8 bg-primary/40" />
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              Manifesto
            </span>
            <span className="h-px w-8 bg-primary/40" />
          </div>

          <blockquote className="font-default font-bold leading-[1.1] tracking-tight text-foreground" style={{
          fontSize: "clamp(2rem, 5vw, 4.5rem)"
        }}>
            <span className="text-primary/60">&ldquo;</span>
            Evidence is the foundation.
            <br />
            Trust is the result.
            <span className="text-primary/60">&rdquo;</span>
          </blockquote>

          <div className="mt-12 flex flex-col items-center">
            <div className="h-px w-32 mb-5" style={{
            background: "linear-gradient(90deg, transparent 0%, hsl(208, 72%, 50%) 50%, transparent 100%)",
            boxShadow: "0 0 12px var(--primary)"
          }} />
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              — MYB Services
            </p>
          </div>
        </div>
      </div>
    </section>;
}